import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Store } from '../models/store';

@Injectable({
  providedIn: 'root'
})
export class StoreFilterService {
  private selectedStoreFilter = new BehaviorSubject<Store>(null);

  constructor() {
    this.setStoreFilter(this.selectedStoreFilter.value);
  }

  setStoreFilter(store: Store) {
    this.selectedStoreFilter.next(store);
  }

  getStoreFilter(): Observable<Store> {
    return this.selectedStoreFilter.asObservable();
  }
}
